// MARK://dhk8/admin-shell/stores/tenant-store
// The current tenant record (so the admin shell can always show the SANDBOX/LIVE badge,
// and the dashboard can offer "Pasar a Modo en vivo"). Loaded lazily after login.
import { create } from 'zustand'
import { getTenant, goLive as goLiveApi } from '../lib/clients/tenants.js'
import type { TenantAccount } from '../lib/mock-data.js'
import { useAuthStore } from './auth-store.js'

interface TenantState {
  tenant: TenantAccount | null
  loading: boolean
  load: () => Promise<void>
  goLive: () => Promise<void>
}

export const useTenantStore = create<TenantState>((set, get) => ({
  tenant: null,
  loading: false,
  async load() {
    const sess = useAuthStore.getState().session
    if (!sess) { set({ tenant: null }); return }
    set({ loading: true })
    try { set({ tenant: await getTenant(sess.tenantId), loading: false }) }
    catch { set({ loading: false }) }
  },
  async goLive() {
    const sess = useAuthStore.getState().session
    if (!sess) return
    const t = await goLiveApi(sess.tenantId)
    set({ tenant: t ?? (get().tenant ? { ...get().tenant!, mode: 'LIVE' } : null) })
  },
}))
